import { Builder } from '@builder.io/sdk';
import { S5BeforeAfterSection } from '../components/interactive-sections/S5BeforeAfter';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { 
    textColorOptionsLimited, 
    altBackgroundColorOptions,
    backgroundGradientOptions 
} from '../utils/builderColorOptions';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S5BeforeAfterSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S5BeforeAfter,
    friendlyName: 'S5 Before and After',
    inputs: [
        {
            name: 'headline',
            type: 'string',
            friendlyName: 'Headline',
            required: true,
            defaultValue: 'Before and After',
            helperText: 'The main heading displayed at the top of the section',
        },
        {
            name: 'headlineColor',
            type: 'string',
            friendlyName: 'Headline Color',
            enum: textColorOptionsLimited,
            defaultValue: 'Blue',
            helperText: 'Select a color for the headline text',
        },
        {
            name: 'backgroundImage',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            friendlyName: 'Background Image',
            helperText: 'Upload an image to use as the section background',
        },
        {
            name: 'imageSet',
            type: 'list',
            onChange: (options) => {
                const items = options.get('imageSet');
                if (items.length !== 4) {
                    options.set('imageSet', items.slice(0, 4));
                    alert('This section requires exactly 4 before/after image pairs');
                }
                   // check if the list has less than 4 items
                   if (options.get('imageSet').length < 4) {
                    alert('This section requires exactly 4 before/after image pairs')
                }
            },
            friendlyName: 'Before & After Image Pairs',
            helperText: 'Add before and after image pairs for the comparison slider',
            defaultValue: [
                { before: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F4dfdfe26572941f4b26515cc485c1902', after: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F813445b2b8e54b3ca7e466140ef2aa51' },
                { before: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fc30bd3add3d14145b936958ed2ca67e5', after: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Ff97e37718cae4a3ba05db3373acc2340' },
                { before: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F60c704155ebd457ba7599125e32ec2f5', after: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F95c0df6afd3e43598d22294299452856' },
                { before: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F4dfdfe26572941f4b26515cc485c1902', after: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F813445b2b8e54b3ca7e466140ef2aa51' }
            ],
            subFields: [
                {
                    name: 'before',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    friendlyName: 'Before Image',
                    helperText: 'Upload the "before" image',
                },
                {
                    name: 'altBefore',
                    type: 'string',
                    friendlyName: 'Image Alt Text',
                    required: true,
                    helperText: 'Alt text for the image',
                },
                {
                    name: 'after',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    friendlyName: 'After Image',
                    helperText: 'Upload the "after" image',
                },
                {
                    name: 'altAfter',
                    type: 'string',
                    friendlyName: 'Image Alt Text',
                    required: true,
                    helperText: 'Alt text for the image',
                },
            ],
        },
        ...getBackgroundColorInput({
            backgroundColorName: 'backgroundColor',
            defaultValue: 'Turquoise20',
            backgroundColorsList: altBackgroundColorOptions,
        }),
        ...getBackgroundGradientInput({
            backgroundGradientName: "backgroundGradient",
            backgroundGradientList: backgroundGradientOptions
        }),
        ...getPaddingInputs()
    ],
});
